import Vue from 'vue';
import { extend, ValidationProvider, ValidationObserver } from 'vee-validate';
import { required, email } from 'vee-validate/dist/rules';
import VTextFieldWithValidation from '@/components/validators/VTextFieldWithValidation.vue';

Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);
Vue.component('VTextFieldWithValidation', VTextFieldWithValidation);

extend('required', {
  ...required,
  message: 'Toto pole je povinné',
});

extend('email', {
  ...email,
  message: 'E-mail nemá správný formát',
});

extend('minTonerCount', {
  message: 'Počet kusů musí být větší nebo rovno 0',
  validate(number) {
    return new Promise((resolve) => {
      resolve({ valid: number >= 0 });
    });
  },
});

extend('customerCountLength', {
  message: 'Délka musí být větší nebo rovno 6 znaků',
  validate(value) {
    return new Promise((resolve) => {
      resolve({ valid: value.length >= 6 });
    });
  },
});

function asDate(date) {
  if (!date) return null;
  const [day, month, year] = date.split('.');
  return new Date(`${year}/${month}/${day}`);
}

function monthDiff(d1, d2) {
  if (!d1 || !d2) return null;
  let months;
  months = (d2.getFullYear() - d1.getFullYear()) * 12;
  months -= d1.getMonth();
  months += d2.getMonth();
  return months <= 0 ? 0 : months;
}

extend('range', {
  message: 'Rozsah musí být <= 6 měsíců',
  params: ['since', 'until'],
  validate(value, { since, until }) {
    const d1 = asDate(since);
    const d2 = asDate(until);
    const months = monthDiff(d1, d2);
    console.log(months);
    return new Promise((resolve) => {
      resolve({ valid: Math.abs(months) < 6 && d1 <= d2 });
    });
  },
});
